import { AlertTriangle, Clock, Pause, Flame } from "lucide-react";
import { fmtCompact as fmt } from "./utils";

function badgeTone(days) {
  if (days >= 60) return "bg-red-100 text-red-800 dark:bg-red-950/60 dark:text-red-200";
  if (days >= 30) return "bg-amber-200 text-amber-900 dark:bg-amber-800/60 dark:text-amber-100";
  return "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200";
}

export function OverdueOwners({ overdue, filteredOverdue, onOpenTimeline }) {
  if (!overdue || overdue.length === 0) return null;
  return (
    <div className="mb-6 border border-amber-300/60 rounded-lg bg-amber-50/50 dark:bg-amber-950/20 overflow-hidden" data-testid="overdue-owners-section">
      <div className="px-4 py-2 text-[10px] uppercase tracking-[0.2em] font-semibold text-amber-800 dark:text-amber-300 flex items-center gap-2 border-b border-amber-300/40 bg-amber-100/40 dark:bg-amber-900/30">
        <AlertTriangle size={12} /> Overdue owners · {overdue.length}
      </div>
      <div className="divide-y divide-amber-300/40">
        {filteredOverdue.map((o) => (
          <button type="button" key={o.user_id} onClick={() => onOpenTimeline(o)}
                  className="w-full text-left p-3 flex items-center justify-between gap-3 flex-wrap hover:bg-amber-100/40 dark:hover:bg-amber-900/20 transition-colors"
                  data-testid={`overdue-row-${o.user_id}`}>
            <div className="min-w-0">
              <div className="text-sm font-medium">{o.user_name}</div>
              <div className="text-xs text-muted-foreground">{o.user_email || "—"}{" · "}{o.invoice_count} invoice(s) · {fmt(o.total)}</div>
              <div className="text-[11px] text-muted-foreground mt-1 flex items-center gap-1 flex-wrap">
                <Clock size={10} />
                {o.last_reminded_at ? (
                  <span data-testid={`last-chased-${o.user_id}`}>Last chased {new Date(o.last_reminded_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                    {o.last_reminded_kind && <span className="opacity-70"> · {o.last_reminded_kind.replace("_", " ")}</span>}
                  </span>
                ) : (
                  <span className="italic opacity-70" data-testid={`never-chased-${o.user_id}`}>Never chased</span>
                )}
                {o.on_plan && o.payment_plan_note && (
                  <span className="ml-2 italic opacity-80" data-testid={`plan-note-${o.user_id}`}>· “{o.payment_plan_note}”</span>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2 flex-wrap justify-end">
              {o.on_plan && (
                <span className="text-[10px] uppercase tracking-widest rounded px-2 py-1 bg-sky-100 text-sky-800 dark:bg-sky-900/60 dark:text-sky-200 font-semibold inline-flex items-center gap-1" data-testid={`plan-badge-${o.user_id}`}>
                  <Pause size={11} /> On plan · {o.payment_plan_until}
                </span>
              )}
              {o.escalated && (
                <span className="text-[10px] uppercase tracking-widest rounded px-2 py-1 bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-200 font-semibold inline-flex items-center gap-1" data-testid={`escalated-badge-${o.user_id}`}>
                  <Flame size={11} /> Escalated
                </span>
              )}
              <span className={`text-[10px] uppercase tracking-widest rounded px-2 py-1 font-semibold inline-flex items-center gap-1 ${badgeTone(o.max_days_overdue)}`}
                    data-testid={`overdue-badge-${o.user_id}`}>
                {o.max_days_overdue} day{o.max_days_overdue === 1 ? "" : "s"} overdue
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
